import { render } from "./UndoVariant.vue?vue&type=template&id=17925a1f"
import script from "./UndoVariant.vue?vue&type=script&lang=js"
export * from "./UndoVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__